import { KYCDocumentType } from "@/features/kyc/types";
import type { FullCountry, UserType } from "@/features/user/types.ts";

export type SourceIncome = {
  Code: number;
  Nom: string;
  NomEn: string;
  uuid: string;
  id: number;
  defaultName: string;
};
export type SourceIncomeResponse = {
  sourceIncomeCodes: SourceIncome[];
};
export type bronzeCategories = {
  code: number;
  name: string;
  english_name: string;
  uuid: string;
  id: number;
  defaultName: string;
};
export type movableIncome = {
  Code: number;
  Nom: string;
  NomEn: string;
  uuid: string;
  id: number;
  defaultName: string;
};

export type NewIdentitySourceIncome = {
  id: number;
  comment: string | null | undefined;
};

export type AccountReason = {
  name: string;
  english_name: string;
  id: string;
};

export type PaymentUsage = {
  name: string;
  english_name: string;
  id: string;
};

export type StepsSettings = {
  current?: number;
  previous: string;
  next: string;
  condition_next?: string;
  condition_previous?: string;
};
export type QuizResponses = {
  documentType?: KYCDocumentType | null;
  sources_income: sourceIncomeType[];
  monthly_income: monthlyIncome;
  account_reasons: accountReasons[];
  payments_usage: paymentsUsage[];
  european_account: {
    trans_key: string | null;
    iban: string | null;
  };
  code_promo: string | null;
  account_usage: {
    trans_key: string | null;
  };
  natural_pro_activity: {
    description: string | null;
  };
  check_register: {
    trans_key: string | null;
  };
  register_info: {
    country: string | null;
    number: string | null;
  };
  countryIban?: string | null;
};

export type sourceIncomeType = {
  source_income_id: string;
  comment: string | null;
};
export type monthlyIncome = {
  trans_key: string | null;
  minimum: number | null;
  maximum: number | null;
};
export type accountReasons = {
  id: string;
};
export type paymentsUsage = {
  id: string;
  comment: string | null;
};
export type stepSettingObjItem = {
  current: number;
  previous?: ModalIbanAccountStep;
  next?: ModalIbanAccountStep;
  condition_next?: ModalIbanAccountStep;
  condition_previous?: ModalIbanAccountStep;
};

export type stepsSettingsType = {
  [key: string]: stepSettingObjItem;
};
export enum ModalIbanAccountStep {
  WelcomeStep,
  IdentityDocument,
  Start,
  SourcesIncome,
  MonthlyIncome,
  AccountReasons,
  PaymentUsage,
  NifVerification,
  EuropeanAccount,
  VideoVerification,
  Country,
  Loading,
  Success,
  Error,
  ValidatingIban,
  AccountUsage,
  NatureProActivity,
  CheckCommercialRegister,
  CommercialRegisterInfo,
  FinalLevl3Step,
  close
}

export type QuizStepProps = {
  setStep: (next: ModalIbanAccountStep) => void;
  ModalIbanAccountStep?: ModalIbanAccountStep;
  quizResponses?: QuizResponses;
  setQuizResponses?: React.Dispatch<React.SetStateAction<QuizResponses>>;
  stepSettings: stepSettingObjItem;
  setPrevStep: (step: ModalIbanAccountStep) => void;
  totalSteps?: number;
  user?: UserType;
  custom_scenario?: boolean;
  countries?: {
    countries: FullCountry[];
  };
};

export type CheckIbanBic = {
  success: boolean;
  bic?: string;
};
export type CheckValidationIban = {
  success: boolean;
  data?: {
    uuid: string;
    valid: boolean | null;
  };
};

export type CreateQuizResponse = {
  success: boolean;
};
